import { FieldQualifierValue } from './getCqlFieldQualifierValue';
import { FIELDS_TO_MASK_MAP, SEARCH_QUALIFIER_MASK_MAP } from '../constants';

export const getMaskedQuery = ({
  field,
  qualifier,
  value,
}: FieldQualifierValue): string => {
  return `${FIELDS_TO_MASK_MAP[field]} ${SEARCH_QUALIFIER_MASK_MAP[qualifier]} "${value}"`;
};
